import { ButtonLink, Header } from '@asgard/ui-library';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import Slider from 'react-slick';
import * as S from './SuccessCases.styled';
import { SuccessCasesProps } from './SuccessCases.types';

export const SuccessCases: React.FC<SuccessCasesProps> = ({ items }) => {
  const { t } = useI18n('hr-as-a-service');

  const sliderSettings = {
    dots: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1.65,
    slidesToScroll: 1
  };

  return (
    <S.Root>
      <S.Intro>
        <Header as="h3" size="5xl" editorial>
          <HtmlTrans
            ns="hr-as-a-service"
            i18nKey={'hr-as-a-service.success-cases.title'}
          />
        </Header>
      </S.Intro>

      <Slider {...sliderSettings}>
        {items.map(
          ({
            id,
            attributes: {
              title,
              successCaseTitle,
              successCaseUrl,
              image: {
                data: {
                  attributes: { url }
                }
              }
            }
          }) => (
            <S.FeatureWrapper key={id}>
              <S.Feature
                style={{
                  backgroundImage: `url(${url})`
                }}
              >
                <S.FeatureContent>
                  <S.Badge>{title}</S.Badge>

                  <Header as="h4" size="3xl">
                    {successCaseTitle}
                  </Header>

                  <ButtonLink
                    href={successCaseUrl}
                    target="_blank"
                    schema="brand2"
                    variant="hard"
                    endIcon={faArrowRight}
                    size="xs"
                    label={t('hr-as-a-service.success-cases.cta')}
                  />
                </S.FeatureContent>
              </S.Feature>
            </S.FeatureWrapper>
          )
        )}
      </Slider>
    </S.Root>
  );
};
